import { render } from "./CorporateNameList.vue?vue&type=template&id=16a5b6cc"
import script from "./CorporateNameList.vue?vue&type=script&lang=js"
export * from "./CorporateNameList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__